import React from "react";
import styles from "./mobile-page.module.css";

export function MobilePage() {
  return (
    <h2 className={styles.root}>Use a desktop browser to use the platform.</h2>
  );
}
